import * as React from "react";

import {
  Avatar,
  Badge,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { Plus, X } from "react-feather";

import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";
import { useFormikContext } from "formik";

const Input = styled("input")({
  display: "none",
});

const Picture = styled(Avatar)`
  height: 8.75rem;
  width: 6.25rem;
  border-radius: 0;
  border-radius: ${(props) => props.theme.shape.borderRadiusSwitch}px;
`;

const PlusContainer = styled(Box)`
  opacity: 0.8;
  background-color: ${(props) => props.theme.palette.background.paper};
  border-radius: ${(props) => props.theme.shape.borderRadiusSwitch}px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 8.75rem;
  width: 6.25rem;

  &:hover {
    opacity: 1;
  }
`;

const XButtonContainer = styled(IconButton)`
  z-index: 10;
  opacity: 1;
  background-color: ${(props) => props.theme.palette.background.default};
  height: 1.875rem;
  width: 1.875rem;

  &:hover {
    opacity: 0.7;
    background-color: ${(props) => props.theme.palette.background.default};
  }
`;

const Title = styled(Typography)`
  font-weight: bold;
`;

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });

const UploadFile = ({ title = "Bookfile", name, accept, altImg, ...props }) => {
  const [file, setFile] = React.useState();
  const { setFieldValue } = useFormikContext();

  const handleCreateUploadPhoto = async (e) => {
    const base64Image = await fileToBase64(e?.target?.files[0]);
    setFile(base64Image);
    setFieldValue(name, e?.target?.files[0]);
  };

  if (file) {
    return (
      <Grid container direction="column" alignItems="center">
        <Title sx={{ mb: 1.6 }}>{title}</Title>
        <Badge
          badgeContent={
            <Paper elevation={16}>
              <XButtonContainer onClick={() => setFile()}>
                <X />
              </XButtonContainer>
            </Paper>
          }
        >
          <Picture src={altImg ? altImg : file} alt="book" />
        </Badge>
      </Grid>
    );
  }
  return (
    <Grid container direction="column" alignItems="center" width="100%">
      <Title>{title}</Title>
      <label htmlFor={name}>
        <Input
          accept={accept}
          id={name}
          type="file"
          onChange={handleCreateUploadPhoto}
          size={0}
        />
        <IconButton
          color="secondary"
          disableFocusRipple
          disableRipple
          aria-label="upload picture"
          component="span"
        >
          <PlusContainer>
            <Plus />
          </PlusContainer>
        </IconButton>
      </label>
    </Grid>
  );
};

export default UploadFile;
